const { MOMENT } = require('./constants')
// const CONFIG = require('./config')
// const request = require('request')
const moment = require('moment-timezone')
// const mdsqr = require('./mdsqr')
const URLS = require('./urls')
// import URLS from '@/lib/urls'
const axios = require("axios");

async function getHeadersInfo(){
  let headers_info = {
    'Content-Type' : 'application/json',
    'Authorization' : 'Token ' + URLS.API_PY_TOKEN,
  }

  return headers_info;
}

async function getSecureKey(){
  let today = new Date();
  let month = today.getMonth() + 1;  // 월
  let date = today.getDate();  // 날짜
  let secure_key = (month + date) * 12;

  return secure_key;
}

async function location (val) {
  let c_type = 'KR';
  let ret_data = null;
  let secure_key = await getSecureKey();
  let headers_info = await getHeadersInfo();
  let uri = URLS.API_PY + 'geolocation/' + secure_key + '/lat_lng_from_addr/';
  let params = {
    address: val,
  }

  await axios({
    method: 'get',
    url: uri,
    params: params,
    headers: headers_info,
  }).then((response) => {
    // console.log(response);
    if(!response.data.has_error){ //성공
      // console.log('success::', response.data);
      // ret_data = response.data.resp;
      ret_data = response.data;
    }else{ //실패
      console.log('error');
      ret_data = response.data;
    }
  }).catch((error) => {
    console.log('error!: ', error);
  }).finally(() => {
  
  });
  return ret_data;
}

async function uploadPrescription (val) {
  let c_type = 'KR';
  let ret_data = null;
  let secure_key = await getSecureKey();
  
  let headers_info = { // multipart/form-data 로 보내기 위해 따로 선언
    'Content-Type' : 'multipart/form-data',
    'Authorization' : 'Token ' + URLS.API_PY_TOKEN,
  }

  let formData = new FormData();
  formData.append('note_id', val.note_id);
  formData.append('consult_result_id', val.consult_result_id);
  formData.append('consult_type', val.consult_type);
  formData.append('file_type', val.file_type);
  formData.append('is_encryption', val.is_encryption);
  formData.append('pass', val.pass);
  formData.append('file', val.file);

  let uri = URLS.API_PY + 'ik/appdata/file/saver/' + secure_key + '/';
  let data = formData;
  await axios({
    method: 'post',
    url: uri,
    data: data,
    headers: headers_info,
  }).then((response) => {
    // console.log('response: ', response);
    if(!response.data.has_error){ //성공
      // console.log('success::', response.data);
      // ret_data = response.data.resp;

      if(response.data.resp && response.data.resp.length > 0){
        for(let i=0; i<response.data.resp.length; i++){
          let fullUrl = null;
          if(response.data.resp[i].file_original){
            fullUrl = URLS.S3_ROOT + response.data.resp[i].file_original;
          }
          response.data.resp[i].file_original = fullUrl;

          fullUrl = null;
          if(response.data.resp[i].file_raw){
            fullUrl = URLS.S3_ROOT + response.data.resp[i].file_raw;
          }
          response.data.resp[i].file_raw = fullUrl;

          fullUrl = null;
          if(response.data.resp[i].file_watermarked){
            fullUrl = URLS.S3_ROOT + response.data.resp[i].file_watermarked;
          }
          response.data.resp[i].file_watermarked = fullUrl;
        }
      }
      ret_data = response.data;
    }else{ //실패
      console.log('error');
      ret_data = response.data;
    }
  }).catch((error) => {
    console.log('error!: ', error);
  }).finally(() => {
  });

  return ret_data;
}

async function sendFax (val) {
  let c_type = 'KR';
  let ret_data = null;
  let secure_key = await getSecureKey();
  let headers_info = await getHeadersInfo();
  let uri = URLS.API_PY + 'fax/' + secure_key + '/send/';
  let data = {
    document_url: val.document_url, // fax 전송할 문서
    receiver_fax: val.receiver_fax, // 수신자 번호
    receiver_name: val.receiver_name, // 수신자 이름
    sender_fax: val.sender_fax, // 송신자 번호
    sender_name: val.sender_name, // 송신자 이름
    note_id: val.note_id,
    is_alarm: val.is_alarm ? val.is_alarm : false,
    pharmacy_fax_type: val.pharmacy_fax_type ? val.pharmacy_fax_type : null,
  }

  await axios({
    method: 'post',
    url: uri,
    data: data,
    headers: headers_info,
  }).then((response) => {
    // console.log('python response: ', response);
    if(!response.data.has_error){ //성공
      // console.log('success::', response.data);
      // ret_data = response.data.resp;
      ret_data = response.data;
    }else{ //실패
      console.log('error');
      ret_data = response.data;
    }
  }).catch((error) => {
    console.log('sendFax error!: ', error);
  }).finally(() => {

  });

  return ret_data;
}

async function encryptionData (s_data, what) {
  let c_type = 'KR';
  // let code = await mdsqr.getCodeName(26, c_type, 999);  //암호화code(ik)
  let code = 'ik'
  let secure_key = await getSecureKey();
  let headers_info = await getHeadersInfo();
  let ret_data = null;
  if(s_data == null || !s_data){
    return s_data;
  }

  if(!what){
    what = 1;
  }
  
  let body_info = {
    'target' : s_data,
    'what' : what, // 1: 암호화, 2: 복호화
  }

  let uri = URLS.API_PY + code + '/appdata/mdtalk/' + secure_key + '/';
  let {data} = await axios.post(uri, body_info, {headers: headers_info}) ;

  if(!data.has_error) {    
    // console.log('success::', data);
    ret_data = data.resp;
  } else {
    console.log('fail::', '암복호화 실패');
  }

  // console.log('success ret_data::', ret_data);
  return ret_data;
}

// 첨부파일 10개 업로드
async function uploadImage10 (val) {
  let c_type = 'KR';
  let ret_data = null;
  let secure_key = await getSecureKey();
  
  let headers_info = { // multipart/form-data 로 보내기 위해 따로 선언
    'Content-Type' : 'multipart/form-data',
    'Authorization' : 'Token ' + URLS.API_PY_TOKEN,
  }
  let formData = new FormData();

  let env = '';
  if(process.env.NODE_ENV === 'production'){
    env = 'prod';
  }else{
    env = 'test';
  }
  let date = moment().format('YYYYMMDD').toString();
  let path = 'node/' + env + '/dr/' + val.dr_id + '/' + val.uid + '/' + date;

  formData.append('files', val.file);
  formData.append('path', path);

  let uri = URLS.API_PY + 'files_uploader/' + secure_key + '/module/file/upload/';
  let data = formData;

  await axios({
    method: 'post',
    url: uri,
    data: data,
    headers: headers_info,
  }).then((response) => {
    // console.log('response uploadImage10: ', response);
    if(!response.data.has_error){ //성공
      // console.log('success::', response.data);
      ret_data = response.data;
    }else{ //실패
      console.log('error');
      ret_data = response.data;
    }
  }).catch((error) => {
    console.log('error!: ', error);
  }).finally(() => {
  });

  return ret_data;
}

async function deleteS3Image (val) {
  let c_type = 'KR';
  let ret_data = null;
  let secure_key = await getSecureKey();
  let headers_info = await getHeadersInfo();
  // let uri = URLS.API_PY + 'files_uploader/' + secure_key + '/s3/file/delete/' + val.file_key;
  let uri = URLS.API_PY + 'files_uploader/' + secure_key + '/module/file/delete/'
  let data = {
    file_name: val.file_name, // full_url
  }

  await axios({
    method: 'delete',
    url: uri,
    data: data,
    headers: headers_info,
  }).then((response) => {
    // console.log('response deleteS3Image: ', response);
    if(!response.data.has_error){ //성공
      // console.log('success::', response.data);
      // ret_data = response.data.resp;
      ret_data = response.data;
    }else{ //실패
      // console.log('error');
      ret_data = response.data;
    }
  }).catch((error) => {
    console.log('error!: ', error);
  }).finally(() => {

  });

  return ret_data;
}

async function encryptPrescription (val) {
  let ret_data = null;
  let secure_key = await getSecureKey();
  let headers_info = await getHeadersInfo();
  let uri = URLS.API_PY + 'ik/appdata/file/encrypt/' + secure_key + '/';

  let data = {
    returned_file_id: val.returned_file_id,
    file_id: val.file_id,
    note_id: val.note_id,
    uid: val.uid,
    dr_id: val.dr_id,
    dr_name: val.dr_name,
    push_msg: val.push_msg,
    pass: val.pass,
  }

  await axios({
    method: 'post',
    url: uri,
    data: data,
    headers: headers_info,
  }).then((response) => {
    // console.log('python response: ', response);
    if(!response.data.has_error){ //성공
      // console.log('success::', response.data);
      // ret_data = response.data.resp;
      ret_data = response.data;
    }else{ //실패
      console.log('error');
      ret_data = response.data;
    }
  }).catch((error) => {
    console.log('encryptPrescription error!: ', error);
  }).finally(() => {

  });

  return ret_data;
}

export default { 
  location,
  uploadPrescription,
  sendFax,
  encryptionData,
  uploadImage10,
  deleteS3Image,
  encryptPrescription,
}